<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeCI(ciToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm12 md6 lg3 pa-4 mt-3>
                <v-hover>
                    <v-card slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-flex xs12>
                            <v-flex xs12 pt-4 pb-3 pr-2 pl-4>
                                <span class="title">Brand CIs</span>
                            </v-flex>
                            <v-divider></v-divider>
                            <v-progress-linear class="branch-office-loading" :active="loading"
                                               :indeterminate="true"></v-progress-linear>
                        </v-flex>
                        <v-list class="branchOfficesList" two-line subheader>
                            <template v-for="(item, index) in items">
                                <v-list-tile ripple avatar
                                             @click="editCI(index)">
                                    <v-list-tile-avatar>
                                        <v-icon>business_center</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{item.name}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>{{item.primary_color}} - {{item.secondary_color}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon ripple @click="showDeleteDialog(index)">
                                            <v-icon color="red lighten-1">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </template>
                        </v-list>
                        <v-flex v-if="items == null || items.length <= 0">
                            <v-card-text><p class="text-xs-center grey--text">No Brand CI yet</p></v-card-text>
                        </v-flex>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn mt-5 dark color="secondary" @click="addNewCI">Add
                                <v-icon class="white--text" right>add</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-hover>
            </v-flex>

            <v-flex xs12 md12 lg9 pa-4 mt-3>

                <v-hover>
                    <v-card v-show="!formDisabled"
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-layout wrap>
                            <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                <v-layout wrap>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">General</span>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field  :disabled="formDisabled"
                                                      v-model="selectedItem.name"
                                                      label="Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field prepend-icon="fas fa-hashtag" :disabled="formDisabled"
                                                      v-model="selectedItem.secondary_color"
                                                      label="Primary Color"
                                                      maxlength="6">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field prepend-icon="fas fa-hashtag" :disabled="formDisabled"
                                                      v-model="selectedItem.primary_color"
                                                      label="Secondary Color"
                                                      maxlength="6">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md5 pt-2 pl-4 pr-4>
                                <v-layout wrap>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">Logo</span>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex md8 xs12>

                                        <UploadDocumentPicker input-accept="image/png"
                                                              input-ref="png"
                                                              v-model="uploadedDocument"
                                                              label="Select PNG"
                                        >
                                        </UploadDocumentPicker>

                                    </v-flex>
                                    <v-flex offset-md1 md3 xs12>
                                        <v-layout>
                                            <v-spacer></v-spacer>
                                            <DocumentTokenChip
                                                    v-show="selectedItem.main_logo_documents_id !== null"
                                                    :documentsId="selectedItem.main_logo_documents_id"
                                                    :documentFilename="selectedItem.name + '.png'"
                                            >
                                            </DocumentTokenChip>
                                        </v-layout>
                                    </v-flex>

                                </v-layout>
                            </v-flex>


                        </v-layout>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                                   @click.native="saveAndGoToNextTab(3)">Save
                                <v-icon class="white--text" right>save</v-icon>
                            </v-btn>
                        </v-card-actions>

                    </v-card>
                </v-hover>

            </v-flex>
        </v-layout>

    </div>
</template>


<script>
    import UploadDocumentPicker from '../../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'

    import {BrandConfigurationCI, Settings} from '../../../store/namespace-helper'

    export default {
      components: {
        UploadDocumentPicker,
        DocumentTokenChip
      },
      name: 'brand-configuration-ci',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          removeDialog: false,
          ciToDelete: null,
          onDismissed: false,
          ciUpdated: 0,
          formDisabled: true,
          uploadedDocument: null
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadItems()
            } else {
              this.formDisabled = true
              this.ciUpdated = 0
              this.$store.dispatch(BrandConfigurationCI.actions.setSelectedBrandConfigurationCI, null)
              console.log('Brand CIs not visible!!!')
            }
          }
        },
        loadItems () {
          this.$store.dispatch(BrandConfigurationCI.actions.loadBrandConfigurationCIs)
        },
        editCI (index) {
          this.formDisabled = false
          this.$store.dispatch(BrandConfigurationCI.actions.setSelectedBrandConfigurationCI, this.items[index])
        },
        showDeleteDialog (index) {
          this.removeDialog = true
          this.ciToDelete = index
        },
        removeCI (index) {
          this.removeDialog = false
          this.$store.dispatch(BrandConfigurationCI.actions.removeCI, this.ciToDelete)
          this.ciUpdated = 0
          this.formDisabled = true
        },
        addNewCI () {
          let ci = {
            id: null,
            name: 'New Brand CI',
            primary_color: '',
            secondary_color: '',
            main_logo_documents_id: null
          }
          this.$store.dispatch(BrandConfigurationCI.actions.setSelectedBrandConfigurationCI, ci)
          this.$store.dispatch(BrandConfigurationCI.actions.addNewCI, ci)
        },
        saveAndGoToNextTab (index) {
          this.$store.dispatch(BrandConfigurationCI.actions.saveBrandConfigurationCI, this.items)
          this.ciUpdated = 0
        }

      },
      computed: {
        selectedItem () {
          return this.$store.getters[BrandConfigurationCI.getters.getSelectedBrandConfigurationCI]
        },
        items () {
          return this.$store.getters[BrandConfigurationCI.getters.brandConfigurationCIs]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('ci formEdited: ' + this.ciUpdated)
          return this.ciUpdated < 2
        }
      },
      watch: {
        items: {
          handler (val) {
            console.log('brand ci data changed: ' + JSON.stringify(val))
            this.ciUpdated++
          },
          deep: true
        },
        uploadedDocument: {
          handler (val) {
            console.log('document uploaded: ' + JSON.stringify(val))
            this.selectedItem.main_logo_documents_id = val.id
          },
          deep: true
        }

      }
    }
</script>

<style scoped>
    .branchOfficesList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-loading {
        margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Settings/BrandConfiguration/BrandConfigurationCI.vue